import {
  Button,
  Container,
  Grid,
  Typography,
  useTheme,
  Divider,
  Dialog,
  DialogTitle,
  DialogContent,
  Card,
  CardContent,
} from '@mui/material';
import StorefrontIcon from '@mui/icons-material/Storefront';
import AskIcon from '@mui/icons-material/ArrowForward';
// import IconButton from '@mui/material/IconButton';
import { useEffect, useState } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, Navigate } from 'react-router-dom';
import {
  // Discount,
  setCart,
  DefaultStore,
  UpdateCartData,
  updateUser,
  setUser,
  DefaultStoreFee,
  LoadDeliveryFees,
  activeMenu,
  allactiveMenues,
  menues,
  checkStore,
} from '@tabletuck/redux-slices';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import CancelRoundedIcon from '@mui/icons-material/CancelRounded';
import { CustomButton } from '@tabletuck/components';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import { MdLocalShipping } from "react-icons/md";
import { HiArrowLongRight } from "react-icons/hi2";
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import basket from '../../../assets/emptyCart.png';
import CartDrawerCard from '../../components/Card/CartDrawerCard';

import banner from '../../../assets/banner.png';
import logo from '../../../assets/white-logo.png';
import Frame from '../../../assets/Cart.png';
import TextField from '@mui/material/TextField';
import { environment } from 'apps/table-tuck-web/src/environments/environment';
import { checkCoupon, setDefaultStore, makeAPICall } from '../../components/CartDrawer/utils';
import DeliveryDialog from '../../components/CartDrawer/DeliveryDialog';
import DailogForm from '../../components/CartDrawer/DailogForm';
import { auth, firestore } from '@tabletuck/firebase-services';
import Snipper from '../../components/CartDrawer/Snipper';
import BillDetails from '../../components/CartDrawer/BillDetails';
import ReportGmailerrorredIcon from '@mui/icons-material/ReportGmailerrorred';
import {
  CheckItem,
  DefaultAddress,
  setDeliveryStore,
  UdpateNote,
  updateCode,
} from '../../../../../../libs/redux-slices/src';
import { useTranslation } from 'react-i18next';
const Cart = ({
  handleCloseCartDialoge,
  openCartDialoge,
  defaultStoreAdress,
  setDefaultStoreAdress,
}) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [t, i18n] = useTranslation();

  const mdDown = useMediaQuery(theme.breakpoints.down('md'));
  const note = useSelector((state) => state.shopReducer.note);
  const cart = useSelector((state) => state.shopReducer.cart);
  const token = useSelector((state) => state.authReducer.token);
  const stores = useSelector((state) => state.shopReducer.stores);
  const user = useSelector((state) => state.authReducer.userData);
  const items = useSelector((state) => state.shopReducer.currentItem);
  const { code } = useSelector((state) => state.shopReducer.cartData);
  const addresses = useSelector((state) => state.authReducer.userAddresses);
  const deliveryStore = useSelector((state) => state.shopReducer.deliveryStore);
  // console.log('stores in redux length', stores.length);
  // console.log('stores in redux', stores);
console.log("user in redux" , user);
  const [err, setErr] = useState('');
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [store, setStore] = useState('');
  const [open, setOpen] = useState(false);
  const [openSelectStore, setOpenSelectStore] = useState(false);

  const [tempNote, setNote] = useState('');
  const [coupon, setCoupon] = useState('');
  const [reset, setRest] = useState(false);
  const [storeId, setStoreId] = useState('');
  const [itemErr, setItemErr] = useState('');
  const [discount, setDiscount] = useState(0);
  const [editCpn, setEditCpn] = useState(true);
  const [cartData, setCartData] = useState(cart);
  const [couponRes, setCouponRes] = useState('');
  const [dataStore, setDataStore] = useState([]);
  const [storesFee, setStoresFee] = useState({});
  const [totalPrice, setTotalPrice] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [isVerify, setIsverify] = useState(false);
  const [defaultAdd, setDefaultAdd] = useState('');
  const [outofStock, setOutOfStock] = useState('');
  const [checkStock, setCheckStock] = useState('');
  const [typeAddress, setTypeAddress] = useState('');
  const [checkoutErr, setCheckoutErr] = useState('');
  const [storeaddress, setStoreaddress] = useState('');
  const [addressStore, setAddressStore] = useState([]);
  const [enableDineIn, setEnableDineIn] = useState(false);
  const [enablePickup, setEnablePickup] = useState(false);
  const [outofStockTime, setOutofStockTime] = useState(null);
  const [enableDelivery, setEnableDelivery] = useState(false);
  const [type, setType] = useState(user?.pickupOrDelivery);
  const [outofStockcheck, setOutofStockcheck] = useState(false);
  const [checkStockDelivery, setCheckStockDelivery] = useState('');
  const [outofStockDelivery, setOutOfStockDelivery] = useState(null);
  const [checkoutErroutofstock, setCheckoutErroutofstock] = useState('');
  const [outofStockTimeDelivery, setOutofStockTimeDelivery] = useState(null);
  const [outofStockDeliveryStore, setOutOfStockDeliveryStore] = useState([]);
  const [outofStockcheckDelivery, setOutofStockcheckDelivery] = useState(false);
  const [deliveryFee, setDeliveryFee] = useState(0);
  const [apiError, setApiError] = useState('');
 const smDown = useMediaQuery(theme.breakpoints.down('sm'));
  const checkItem = useSelector((state) => state.shopReducer.checkItem);
  const types = ['delivery',  'pickup'];
  const page = "page" ;
  const typeToShow = ['Delivery', 'Pickup'];
  const typeToShowAR = ['توصيل', 'تناول في المطعم', 'استلام'];
  const deliveryAddress = useSelector(
    (state) => state.shopReducer.deliveryAddress
  );

  const ApplyCoupon = async () => {
    setCouponRes('');
    setRest(true);
    const { isVerify, discount } = await checkCoupon(
      token,
      coupon,
      setCouponRes,
      setDiscount,
      setIsverify
    );
    if (isVerify) {
      dispatch(updateCode({ code: coupon, discount, isVerify }));
      setCoupon('');
      setEditCpn(false);
    }
    setRest(false);
  };
  useEffect(() => {
    setCartData(cart);
    console.log("cart:" ,cart);
  }, [cart]);

  useEffect(() => {
    setType(user?.pickupOrDelivery);
    console.log("type:",type);
  }, [user]);

  const getStores = async () => {
    stores?.map((store) => {
      if (store?.id === addressStore) {
        setData(store);
      }
    });
  };

  useEffect(() => {
    if (stores && stores.length === 1) {
      setDefaultStore(
        token,
        stores[0].id,
        stores[0].restaurant_name,
        setStore,
        stores[0]?.pickup_enabled,
        setEnablePickup,
        stores[0].dinein_enable,
        setEnableDineIn,
        stores[0].address.displayName,
        setStoreaddress,
        stores[0].address.placeId
      );
    }
  }, [stores]);
  const getAdressStore = async () => {
    stores?.map((store) => {
      if (store?.id === deliveryStore) {
        setOutOfStockDeliveryStore(store?.out_of_stock);
      }
    });
  };

  const getStore = async () => {
    stores?.map((storee) => {
      if (storee?.restaurant_name === store) {
        setDataStore(storee);
      }
    });
  };
  useEffect(() => {
    getStore();
  }, [store, setStore]);

  useEffect(() => {
    getStores();
  }, [addressStore]);

  useEffect(() => {
    getAdressStore();
  }, [deliveryStore]);

  const onDiscount = (data) => setDiscount(data);
  const resetData = () => {
    setCouponRes('');
    setNote('');
    setCoupon('');
  };

  const validateCheckoutData = () => {
    let tt;
    let isDataValid = true;
    if (data.id === addressStore) {
      tt = data.delivery_enabled;
    }

    if (type === '') {
      setCheckoutErr(`${t('basket.plzChooseType')}`);
      isDataValid = false;
    }
    if (type === 'delivery' && tt === undefined) {
      setCheckoutErr(`${t('basket.plzAddAdress')}`);
      isDataValid = false;
    }
    if (type === 'delivery' && !tt) {
      setCheckoutErr(`${t('basket.deliveryNotAvailable')}`);
      isDataValid = false;
    }
    if (type === 'pickup' && !enablePickup) {
      setCheckoutErr(`${t('basket.pickupNotAvailable')}`);
      isDataValid = false;
    }
    if (type === 'dinein' && !enableDineIn) {
      setCheckoutErr(
        store?.length > 0
          ? `${t('basket.dineinNotAvailable')}`
          : `${t('basket.pressTochangeStore')}`
      );
      isDataValid = false;
    }

    cartData.forEach((item) => {
      // console.log('item', item);
      const foundItem = items?.find((i) => i?.id === item.itemId);
      // console.log('all items', items);
      if (!foundItem) {
        setCheckoutErr('This item is not available');
        isDataValid = false;
      } else {
        if (type === 'pickup' && item?.pickup_enabled == false) {
          setCheckoutErr(`${t('basket.removeItemNotAvailable')}`);
          isDataValid = false;
        } else if (type === 'dinein' && item?.dinein_enabled == false) {
          {
            setCheckoutErr(`${t('basket.itemNotAvailableForDineIn')}`);
            isDataValid = false;
          }
        } else if (type === 'delivery' && item?.delivery_enabled == false) {
          setCheckoutErr(`${t('basket.itemNotAvailableForDelivery')}`);
          isDataValid = false;
        }
        // ============checkoutOfstockDineIn orPick=========================
        if (outofStock && outofStock?.length === 0) {
          setCheckoutErroutofstock('');
        } else
          outofStock &&
            outofStock.filter((c) => {
              if (c?.id === item?.itemId) {
                // console.log("id of out ofstock",c.id)
                // console.log("id of item",item.itemId)
                // console.log("out of stock items inside filter",outofStock)
                // console.log("inside filter amal")
                setCheckoutErroutofstock('This item is out of stock');
                setOutofStockTime(
                  new Date(c?.out_of_stock_end_date?.seconds * 1000)
                );
                isDataValid = false;
              } else {
                setCheckoutErroutofstock('');
              }
            });
        // };
        // ====checkoutOfstockDelivery=====
        if (outofStockDelivery && outofStockDelivery?.length === 0) {
          setCheckoutErroutofstock('');
        } else
          outofStockDelivery &&
            outofStockDelivery.filter((c) => {
              if (c?.id === item?.itemId && type === 'delivery') {
                setCheckoutErroutofstock('This item is out of stock');
                setOutofStockTimeDelivery(
                  new Date(c?.out_of_stock_end_date?.seconds * 1000)
                );
                isDataValid = false;
              } else {
                setCheckStockDelivery('');
                setCheckoutErroutofstock('');
              }
            });
      }
    });
    return isDataValid;
  };
  const handleCheckout = () => {
    dispatch(
      UpdateCartData({
        discount,
        code,
        isVerify,
        subTotal: total,
        typeAddress,
        orderType: type,
        storeId,
      })
    );

    if (type === 'delivery') {
      if (defaultAdd && defaultAdd !== 'This address is out of service.') {
        // window.location.href ="https://taqwasbakery.com/";
        navigate('/confirmorder');
        handleCloseCartDialoge();
        dispatch(DefaultAddress(defaultAdd));
      } else setCheckoutErr('Please check your address info');
    } else if (type === 'dinein' || type === 'pickup') {
      // window.location.href ="https://taqwasbakery.com/";
      navigate('/confirmorder');
      handleCloseCartDialoge();
      dispatch(DefaultStore(store));
      dispatch(DefaultStoreFee(storesFee));
    } else {
      dispatch(DefaultStore(store));
      dispatch(DefaultAddress(defaultAdd));
      dispatch(DefaultStoreFee(storesFee));
    }
  };

  const getUser = async (token) => {
    try {
      const User = user;
      console.log("user:",User);
      const bags = User?.bagItems;
      bags?.length && dispatch(setCart(bags));
      const storeId = User?.defaultStore;
      setStoreId(User?.defaultStore);

      stores?.map((store) => {
        if (store?.id === storeId) {
          // setOutOfStock(store?.out_of_stock);
          const outOfStockItems = store?.out_of_stock || [];
          // console.log('all items in array store out of stock', outOfStockItems);
          // Filter out items with end dates in the future
          const futureItems = outOfStockItems.filter((item) => {
            const endDate = new Date(
              item.out_of_stock_end_date.seconds * 1000 +
                item.out_of_stock_end_date.nanoseconds / 1e6
            );
            return endDate > new Date();
          });

          // Update state or variable with filtered items
          setOutOfStock(futureItems);

          // Log the filtered items
          // console.log(
          //   'Filtered out of stock items with future end dates:',
          //   futureItems
          // );

          setStore(store?.restaurant_name);
          setStoresFee(store);
          setEnablePickup(store?.pickup_enabled);
          setEnableDelivery(store?.delivery_enabled);
          setEnableDineIn(store?.dinein_enable);
          setStoreaddress(store?.address?.displayName);
        }
      });
    } catch (e) {
      console.log(e?.message);
    }
  };
  const getUserAddresses = async (token) => {
    const bags = user?.bagItems;
    setStoreId(user?.defaultStore);
    bags?.length && dispatch(setCart(bags));
    const defaultDeliveryAddress = user?.defaultDeliveryAddress;
    try {
      await Promise.all(
        addresses?.map(async (a) => {
          if (a?.id === defaultDeliveryAddress) {
            setAddressStore(a?.delivery_store_id);
            dispatch(
              setDeliveryStore({
                address: defaultDeliveryAddress,
                store: a?.delivery_store_id,
              })
            );
            // try {
            // Make the API call and handle errors
            const apiResponse = await makeAPICall(
              user?.defaultStore,
              a?.id,
              user?.uid
            );
            // Clear any previous error if the API call succeed
            // console.log('apiResponse', apiResponse);
            setDeliveryFee(0);
            dispatch(LoadDeliveryFees(0));
            if (apiResponse?.message || apiResponse?.error) {
              // Handle the error
              // console.log(
              //   'Error occurred during API call:',
              //   apiResponse.error
              // );
              setApiError(apiResponse?.message || apiResponse?.error);
              setDefaultAdd('');
              setDeliveryFee(0);
              dispatch(LoadDeliveryFees(0));
              // Perform error handling or return the error to the appropriate context
            } else {
              // No error, proceed with the obtained fee
              const fee = apiResponse;
              setDeliveryFee(fee);
              setDefaultAdd(a?.displayName);
              setTypeAddress(a?.nickName);
              dispatch(LoadDeliveryFees(fee));
              setApiError('');
            }
          }
        }) ?? []
      );
    } catch (error) {
      console.log('Error in getUserAddresses:', error);
      setApiError(error?.message);
      setDefaultAdd('');
    }
  };

  useEffect(() => {
    user && getUser(auth?.currentUser?.uid);
    auth?.currentUser?.uid && getUserAddresses(auth?.currentUser?.uid);
  }, [user, store]);

  useEffect(() => {
    let items = 0;
    let price = 0;
    let total = 0;
    cartData.forEach((item) => {
      items += item.qty;
      price += item.qty * item.price;
      total += item.calculatedPrice;
    });
    setTotalItems(items);
    setTotalPrice(price);
    setTotal(total);
  }, [
    cartData,
    totalPrice,
    totalItems,
    setTotalPrice,
    setTotalItems,
    setTotal,
    total,
  ]);

  const handleClickOpen = () => {
    setOpen(true);
    setCheckoutErr('');
  };
  const handleClose = () => {
    setOpen(false);
  };
  const handleChangeType = async (value) => {
    dispatch(CheckItem(''));
    setCheckoutErroutofstock('');
    setCheckoutErr('');
    setType(value);
    await firestore
      .collection('users')
      .doc(auth?.currentUser?.uid)
      .set({ pickupOrDelivery: value }, { merge: true })
      .then(() => {
        const updatedUser = { ...user, pickupOrDelivery: value };
        dispatch(setUser({ user: updatedUser }));
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const CheckoutUserSignedin = () => {
    setCouponRes('');
    setEditCpn(false);
    if (validateCheckoutData()) {
      handleCheckout();
      setCheckoutErroutofstock('');
      setCheckoutErr('');
    }
  };

  const CheckoutUserisnotSignedin = () => {
    // handleCloseCartDialoge();
    navigate('/signup');
  };

  const menuDefaultStore = () => {
    dispatch(activeMenu(user?.defaultStore?.active_menu_now));
    dispatch(allactiveMenues(user?.defaultStore?.all_active_menus));
    dispatch(menues(user?.defaultStore?.menus));
   
    navigate('/');
  };

  const handleCloseStore = () => {
    setOpenSelectStore(false);
  };
  const numberToWord = (number) => {
    const words = [
      'Zero',
      'One',
      'Two',
      'Three',
      'Four',
      'Five',
      'Six',
      'Seven',
      'Eight',
      'Nine',
      'Ten',
    ];
    return words[number];
  };

  const handleOpenMenu = () => {
    stores.length > 1 ? setOpenSelectStore(true) : navigate('/');
  };
 







  return (
    <>
      <div
        style={{
          backgroundColor: '#050505FC',
          position: 'relative',
          width: '100%',
          height: '450px',
          backgroundImage: `url(${banner})`,
          backgroundRepeat: 'no-repeat',
        }}
      >
        <div>
          <a href="https://taqwasbakery.com/" style={{ position: 'relative'}}>
  <img
    src={logo}
    alt="logo"
    style={{
      paddingTop: smDown ? '50px' : '10px',
      paddingLeft: '20px',
      display: 'flex',
      cursor: 'pointer',
      width: '6rem',
      position: 'relative',
      zIndex: 1000,
    }}
    
  />
</a>
</div>
        <img
          src={Frame}
          alt="title"
          style={{
            position: 'absolute',
            top: '40%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
          }}
        />
      </div>
      
      <Box  sx={{backgroundColor:'#050505FC' ,padding:"50px" ,paddingBottom:"180px" }} >
      {cartData && cartData?.length && cartData?.length > 0 ? (
    <Grid container >
        <Grid item xs={12}
          md={12}
          lg={7} sx={{backgroundColor:"#151414" ,borderRadius:"30px",marginRight:{xs:"0px",md:"20px" ,lg:"30" } ,marginBottom:"50px"}}>
           
          <div style={{ paddingTop: '50px', display: 'contents' ,backgroundColor:"#151414" }}>
          <Typography
            sx={{color:"white",fontSize:"20px" , fontFamily:"Outfit" ,marginLeft:"20px" ,marginTop:"20px"}}>
                Cart ({cartData?.length})
            </Typography>
          
             {cartData?.map((item, indx) => (
                <CartDrawerCard
                  key={indx + item.itemId}
                  item={item}
                  page ={page}
                  outofStock={outofStock}
                  total={totalPrice}
                  setTotal={setTotalPrice}
                  code={coupon}
                  couponRes={setCouponRes}
                  setDiscount={onDiscount}
                  setIsVerified={setIsverify}
                  typeState={type}
                  setItemErr={setItemErr}
                  itemErr={itemErr}
                  setOutofStockcheck={setOutofStockcheck}
                  setOutofStockcheckDelivery={setOutofStockcheckDelivery}
                  user={user}
                  setRest={setRest}
                  outofStockDeliveryStore={outofStockDeliveryStore}
                  ApplyCoupon={ApplyCoupon}
                  setCoupon={setCoupon}
                  setCouponRes={setCouponRes}
                />
              ))}
            
        
                  </div>
        </Grid>
        <Grid item lg={4} xs={12}>
        {type == 'delivery' ? (
        <DeliveryDialog
          open={open}
          handleDefault={setDefaultAdd}
          handleCloseCartDialoge={handleCloseCartDialoge}
          token={user?.uid}
          setErr={setErr}
          handleClose={handleClose}
          items={addresses}
          setAddressStore={setAddressStore}
          handleFee={setDeliveryFee}
        />
      ) : (
        <DailogForm
          open={open}
          handleClose={handleClose}
          onClickItem={setStore}
          type={type}
          enablePickup={setEnablePickup}
          enableDinin={setEnableDineIn}
          enableDelivery={setEnableDelivery}
          setErr={setErr}
          onClickAdress={setStoreaddress}
          setDefaultStoreAdress={setDefaultStoreAdress}
          defaultStoreAdress={defaultStoreAdress}
        />
      )}
      <Box
        dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}
        sx={{ width: { sm: '100%', lg: '450px' }, padding: '10px' ,backgroundColor:"#151414" ,borderRadius:"30px"}}
      >
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
            <Grid item lg={4}>
            {/* <CustomButton
              bg={environment.mainColor}
              onClick={() =>
                auth?.currentUser?.uid && userData?.defaultStore?.length > 0
                  ? menuDefaultStore()
                  : handleOpenMenu()
              }
              buttonText={`${t('basket.keepOrdering')}`}
            /> */}

          </Grid>
      
          {/* <Grid item lg={4}>
            <CustomButton
              bg={environment.mainColor}
              onClick={() => {
                if (stores.length == 1) {
                  dispatch(
                    activeMenu(stores[0].id?.active_menu_now)
                  );
                  dispatch(
                    allactiveMenues(stores[0].id?.all_active_menus)
                  );
                  dispatch(menues(stores[0].id?.menus));
                }
                navigate('/menu');
                handleCloseCartDialoge();
              }}
              buttonText={`${t('basket.keepOrdering')}`}
            />
          </Grid> */}
        
          <Dialog onClose={handleCloseStore} open={openSelectStore}>
            <div style={{ width: '100%' }}>
              <div
                style={{
                  padding: '15px 20px 0px 0px',
                  display: 'flex',
                  justifyContent: 'end',
                  borderRadius: '25px',
                }}
              >
                {' '}
                <CancelRoundedIcon
                  style={{
                    color: 'black',
                    cursor: 'pointer',
                    marginLeft: '15px',
                  }}
                  onClick={handleCloseStore}
                />
              </div>

              <DialogTitle
                style={{
                  display: 'grid',
                  justifyContent: 'center',
                  textAlign: 'center',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                  }}
                >
                  <Typography
                    component="p"
                    variant="h5"
                    style={{ fontWeight: 'bold' }}
                  >
                    {' '}
                    {numberToWord(stores?.length)} Branches, One Appetite!
                  </Typography>
                </div>

                <Typography
                  component="p"
                  variant="body1"
                  style={{ color: 'gray' }}
                >
                  {numberToWord(stores?.length)} Branches, Endless Choices!
                  Explore our menu at your preferred spot.
                </Typography>

                <div></div>
              </DialogTitle>

              <DialogContent dividers style={{ textAlign: 'center' }}>
                {stores?.map((c) => (
                  <Grid
                    item
                    key={c.id}
                    lg={4}
                    style={{
                      display: 'inline-block',
                      color: 'white',
                      textAalign: 'center',
                      padding: '14px',
                      textDecoration: 'none',
                      cursor: 'pointer',
                      textAlign: 'center',
                    }}
                  >
                    <Card
                      style={{
                        border: '2px solid lightgray',
                        borderRadius: '10px',
                        borderColor: 'gray',
                        width: '180px',
                        cursor: 'pointer',
                      }}
                      onClick={async () => {
                        setDefaultStore(
                          token,
                          c.id,
                          c?.restaurant_name,
                          setStore,
                          c?.pickup_enabled,
                          c?.pickup_enabled,
                          c.dinein_enable,
                          c.dinein_enable,
                          c.address.displayName,
                          c?.address?.displayName
                        );
                        if (
                          user?.bagItems?.length > 0 &&
                          cart?.length > 0
                        ) {
                          dispatch(checkStore(true));
                        } else dispatch(checkStore(false));
                        // onClickItem(item.restaurant_name)
                        handleCloseStore();
                        const updatedUser = {
                          ...user,
                          defaultStore: c.id,
                        };
                        dispatch(setUser({ user: updatedUser }));

                        dispatch(activeMenu(c.id?.active_menu_now));

                        dispatch(allactiveMenues(c.id?.all_active_menus));

                        dispatch(menues(c?.id?.menus));
                        handleCloseCartDialoge();
                        navigate('/menu');
                      }}
                    >
                      <CardContent
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          textAlign: 'center',
                          flexDirection: 'column',
                          alignItems: 'center',
                          height: '245px',
                        }}
                      >
                        <img
                          src={c.image}
                          alt={c.image}
                          style={{
                            width: '100px',
                            height: '80px',
                          }}
                        />
                        <Typography
                          variant="h6"
                          style={{
                            fontWeight: 'bold',
                            color: 'black',
                          }}
                        >
                          {c.restaurant_name}
                        </Typography>
                        <Typography variant="body2" style={{ color: 'gray' }}>
                          {c.address.displayName
                            .split(',')
                            .slice(0, 2)
                            .join(',')}
                        </Typography>
                      </CardContent>
                    </Card>
                  </Grid>
                ))}
              </DialogContent>
            </div>
          </Dialog>
        </Grid>
        {auth?.currentUser && (
          <>
          <Box
  sx={{
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    marginTop: '20px',
    flexDirection: 'row',
    padding: '5px 1%',
    width:"90%",
    mx:"auto",
    backgroundColor: '#2e2e2e', // Common background color
    borderRadius: '30px', // Rounded corners for the background
  }}
>
  {types?.map((value, index) => {
    const isDisabled =
      (store?.length > 0 && !enablePickup && value === 'pickup') ||
      (store?.length > 0 && !enableDelivery && value === 'delivery') ;
    //   (store?.length > 0 && !enableDineIn && value === 'dinein');

    const isActive = type === value;
    console.log("isActive :" ,isActive);

    return !isDisabled ? (
      <Button
        key={value}
        disableRipple
        sx={{
          flex: 1,
          padding: '10px 0',
          backgroundColor: isActive ? '#b71c1c' : 'transparent', // Active and inactive background
          color: isActive ? 'white' : '#d3d3d3', // Active and inactive text colors
          borderRadius: '30px', // Matches button and background style
          fontWeight: 'bold',
          textTransform: 'capitalize',
          transition: 'all 0.3s ease', // Smooth transition for hover effects
          '&:hover': {
            backgroundColor: isActive ? '#b71c1c' : '#3a3a3a', // Subtle hover effect
          },
        }}
        variant={isActive ? 'contained' : 'text'}
        onClick={() => handleChangeType(value)}
      >
        {typeToShow[index]}
      </Button>
    ) : null;
  })}
</Box>


            <Box
              sx={{
                width: '100%',
                padding: '20px 14%',
                display: 'inherit',
                justifyContent: 'center',
                textAlign: 'center',
              }}
              style={{ direction: 'initial' }}
            >
              <Typography
                component="a"
                variant="body1"
                sx={{
                  mr: 2,
                  flexGrow: 1,
                  fontFamily: 'Outfit, sans-serif', 
                  color: '#E1E1E1',
                  fontWeight: 700,
                 
                }}
              >
                {type === 'delivery' ? (
                  (apiError || defaultAdd) && (
                    <Box sx={{ display: 'flex', 
                      justifyContent: 'center', 
                      alignItems: 'center', }}>
                      {apiError ||
                      defaultAdd != `${t('basket.addressOutService')}` ? (
                        <MdLocalShipping
                          sx={{ color:"white" ,mx:"auto"}}
                          fontSize="25"
                          
                        />
                      ) : (
                        <ReportGmailerrorredIcon style={{ color: 'red' }} />
                      )}
                    </Box>
                  )
                ) : (
                  <>
                    <StorefrontIcon
                      fontSize="large"
                      style={{
                        color: 'white',
                        backgroundColor: environment.mainColor,
                        width: '30px',
                        height: '30px',
                        borderRadius: '5px',
                      }}
                    />
                  </>
                )}{' '}
                {type === 'delivery' && !apiError ? (
                  defaultAdd || err
                ) : (
                  <>
                    {store}
                    <br />{' '}
                    <span style={{ fontSize: '12px', fontWeight: 'normal' ,color:"#E1E1E1" }}>
                      {type != 'delivery' && storeaddress}{' '}
                    </span>
                  </>
                )}
                {type === 'delivery' && apiError ? (
                  <>
                    <ReportGmailerrorredIcon style={{ color: 'red' }} />
                    {t('basket.addressOutService')}
                  </>
                ) : (
                  <>
                    {/* {store}
                <br />{' '}
                <span style={{ fontSize: '12px', fontWeight: 'normal' }}>
                  {type != 'delivery' && storeaddress}{' '}
                </span> */}
                  </>
                )}
              </Typography>

              <br />
              <Typography
                component="a"
                variant="body1"
                sx={{
                  mr: 2,
                  flexGrow: 1,
                  fontFamily: 'Outfit, sans-serif', 
                  color: "#b71c1c",
                  fontWeight: 700,
                  cursor: 'pointer',
                }}
                onClick={() => {
                  handleClickOpen(true);
                  // navigate('/menu-items')
                  setCheckoutErr('');
                }}
              >
                {/* {type === 'delivery'
                  ? defaultAdd
                    ? `${t('basket.changeAddress')}`
                    : `${t('basket.changeAddress')}`
                  : `${t('basket.changeStore')}`
                  }{' '}
                <KeyboardDoubleArrowRightIcon /> */}
                {type === 'delivery'
                  ? defaultAdd
                    ? `${t('basket.changeAddress')}`
                    : `${t('basket.changeAddress')}`
                  : ``}{' '}
                {/* {type === 'delivery' && <HiArrowLongRight size={25} />} */}
              </Typography>
            </Box>
           
          </>
        )}


        <Box
          sx={{
            width: '100%',
            padding: '10px 10%',
            display: 'contents',
          }}
        >
         

          
          {!!cartData && !!cartData?.length && cartData?.length > 0 && (
            <>
              {' '}
              <Box
                sx={{
                  width: '92%',
                  mx:"auto",
                  padding: '12px 2%',
                }}
              >
                {' '}
                <Typography
                  component="a"
                  variant="h6"
                  color={"white"}
                  sx={{
                    fontFamily: 'Outfit, sans-serif', 
                    color: "white",
                    fontWeight: 400,
                    display: 'flex',
                  }}
                >
                  {t('basket.addANote')}
                </Typography>
                <TextField
                  id="standard-basic"
                  placeholder={`${t('basket.addANote')}`}
                  variant="outlined"
                  multiline
                  rows={3}
                  value={note}
                  sx={{
                    backgroundColor: '#3E3E3E', 
                    borderRadius: '10px', 
                    '& .MuiOutlinedInput-root': {
                      '& fieldset': {
                        borderColor: '#636363', 
                      },
                      '&:hover fieldset': {
                        borderColor: '#555', 
                      },
                      '&.Mui-focused fieldset': {
                        borderColor: 'gray', 
                      },
                      '& input': {
                        color: '#fff', 
                      },
                      '& textarea': {  // Target textarea for multiline
                        color: '#fff',  // Ensure text color is white for multiline input as well
                      },
                      '& input::placeholder': {
                        color: '#fff', 
                        opacity: 1, 
                      },
                      '& textarea::placeholder': { // Ensure placeholder color is white for multiline as well
                        color:'#636363',
                        opacity: 1,
                      },
                    },
                    '& .MuiInputLabel-root': {
                      color: 'white', 
                    },
                    '& .MuiInputLabel-root.Mui-focused': {
                      color: 'white', 
                    },
                  }}
                  style={{ width: '100%' ,borderRadius:"10px"}}
                  onChange={(e) => dispatch(UdpateNote(e.target.value))} //redux
                />
              </Box>
              <Divider sx={{ border: '1px solid #373737' , width:"90%" , mx:"auto" , my:"20px" }} />

              <Box
  sx={{
    width: '92%',
    mx: "auto",
    padding: '0px',
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#2e2e2e',
    borderRadius: '30px',
    justifyContent: 'space-between',
    gap: '10px',
  }}
>
  {!editCpn ? (
    <>
      <Typography
        sx={{
          color: 'gray',
          flex: 1,
          fontFamily: 'Outfit, sans-serif',
          fontWeight: "bold",
          marginLeft: "15px",
        }}
      >
        {code || `${t('basket.setCoupon')}`}
      </Typography>
      <Button
        sx={{
          backgroundColor: "#b71c1c",
          color: 'white',
          borderRadius: '30px',
          padding: '5px 20px',
          fontWeight: 'bold',
          height: '55px',
          '&:hover': {
            backgroundColor: '#a32020',
          },
        }}
        onClick={() => setEditCpn(true)}
      >
        {t('basket.applyCoupon')}
      </Button>
    </>
  ) : (
    <Box sx={{ display: 'flex', width: '100%', alignItems: 'center' }}>
      <TextField
        id="outlined-basic"
        placeholder={t('basket.applyCoupon')}
        variant="outlined"
        value={coupon}
        onChange={(e) => {
          setCoupon(e.target.value);
          setCouponRes('');
        }}
        onFocus={() => setRest(false)}
        sx={{
          flex: 1,
          backgroundColor: '#3a3a3a',
          borderRadius: '30px 0px 0px 30px',
          '& .MuiOutlinedInput-root': {
            '& fieldset': { borderColor: '#636363' ,borderRadius: '30px 0px 0px 30px' },
            '&:hover fieldset': { borderColor: '#555' },
            '&.Mui-focused fieldset': { borderColor: 'gray' },
          },
          '& input': { color: 'white' },
          '& input::placeholder': { color: 'gray', opacity: 1 },
        }}
      />
      <button
        style={{
          backgroundColor: coupon ? "#b71c1c" : 'gray',
          color: 'white',
          borderRadius: '0px 30px 30px 0px', 
          padding: '5px 20px',
          fontWeight: 'bold',
          fontFamily:'Outfit',
          height: '55px',
          cursor: coupon ? 'pointer' : 'not-allowed',
          '&:hover': {
            backgroundColor: coupon ? '#a32020' : 'gray',
          },
        }}
        onClick={() => {
          if (coupon) ApplyCoupon();
        }}
      >
        {t('basket.applyCoupon')}
      </button>
    </Box>
  )}
</Box>


              <Box
                sx={{
                  width: '100%',
                  margin: '0 10px 5px',
                }}
              >
                <p
                  style={{
                    alignSelf: 'flex-start',
                    textAlign: 'start',
                    fontWeight: '500',
                    fontSize: 15,
                    marginLeft: 10,
                    color: couponRes === 'Success' ? 'green' : 'red',
                  }}
                >
                  {couponRes}
                  {couponRes === `${t('basket.success')}` &&
                    `${t('basket.couponConsiderd')}`}
                </p>
              </Box>
              
            
           
              <BillDetails
                type={type}
                data={data}
                total={total}
                addressStore={addressStore}
                store={store}
                isVerify={isVerify}
                dataStore={dataStore}
                discount={discount}
                deliveryFee={isNaN(deliveryFee) ? 0 : deliveryFee}
              />
              <Typography
                component="a"
                variant="body1"
                color={environment.mainColor}
                sx={{
                  fontFamily: 'Outfit, sans-serif', 
                  color: environment.mainColor,
                  fontWeight: 700,
                  display: 'flex',
                  color: 'red',
                  marginTop: '10px',
                  justifyContent: 'center',
                }}
              >
                <br />
                {checkoutErroutofstock}
                <br />
                {checkoutErr}
                <br />
              </Typography>
              <Box  sx={{width:"82%" , mx:"auto" , mb:4,
              }}>
              <CustomButton
             
                bg={"#b71c1c"}
                onClick={() => {
                  auth?.currentUser
                    ? CheckoutUserSignedin()
                    : CheckoutUserisnotSignedin();
                }}
                buttonText={`${t('basket.procedToCheckout')}`}
                disabled={
                  apiError !== '' ||
                  checkoutErr !== '' ||
                  checkoutErroutofstock !== ''
                }
              />
               
              </Box>
             {' '}
            </>
          )}
        </Box>
      </Box>
        </Grid>
   
      
    </Grid>
            ) : (
              <Container maxWidth="lg">
              <Box
                sx={{
                  backgroundColor: '#121212',
                  boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.3)',
                  borderRadius: '20px',
                  padding: '100px',
                  textAlign: 'center',
                  maxWidth: 'xl',
                  mx: 'auto',
                }}
              >
                <Grid container justifyContent="center" paddingBottom="20px">
                  <Grid item lg={12} display="flex" justifyContent="center">
                    <img src={basket} alt="emptybag" />
                  </Grid>
                </Grid>
            
                <Grid container justifyContent="center" paddingBottom="20px">
                  <div>
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: 'bold',
                        fontFamily: 'Outfit',
                        color: 'white',
                      }}
                    >
                      {t('basket.emptyCart')}
                    </Typography>
                    <br />
                    <Typography
                      variant="body2"
                      sx={{
                        fontWeight: 'bold',
                        color: 'grey',
                        fontFamily: 'Outfit',
                        paddingLeft: '15px',
                      }}
                    >
                      {t('basket.goOnStockOrder')}
                    </Typography>
                  </div>
                </Grid>
            
                <Grid container justifyContent="center" textAlign="center" marginBottom="10px">
                <button style={{backgroundColor:environment.mainColor ,padding:"10px 15px" ,color:"white" ,fontFamily:"Outfit" ,borderRadius:"30px"}} onClick={() =>
                      auth?.currentUser?.uid &&
                      user?.defaultStore?.length > 0
                        ? menuDefaultStore()
                        : handleOpenMenu()
                    }>
Continue Shopping
                  </button>
                </Grid>
              </Box>
            </Container>
          
          )}
    </Box>
    </>
  );
}

export default Cart
